<script>
import { manageStoreMethods } from "@state/helpers";
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
    name: 'AccessPointsModal',
    props: {
        activeStore: {
            type: Object,
            required: false,
            default: () => {}
        },
        callback: {
            type: Function,
            required: false,
            default: () => {}
        },
        closeModal: {
            type: Function,
            required: true
        }
    },
    components: { 
        ValidationProvider, ValidationObserver
    },
    data() {
        return {
            newAP: {
                id: null,
                alias: null,
                server_endpoint: null,
                parameters: ['',''],
                local_ip: null,
                subnet_mask: null,
                gateway: null,
                heartbeat: 15,
            },
            isSubmitting: false,
            isModalVisible: true,
            assignModalShow: false,
            randomId: Math.random()
        }
    },
    methods: {
        ...manageStoreMethods,
        async submitForm() {
            const isValid = await this.$refs.observer.validate();
            const errors = Object.values(this.$refs.observer.errors).flat();
            if (!isValid) {
                this.$generate_noty('warn', this.$t('forms.form_errors', {'errors':errors.length}), this.$t('alerts.error'),  5000, true)
                return
            }
            this.assignModalShow = true;
        },
        saveStore(){
            let context = this
            this.isSubmitting = true
            const payload = (
                this.newAP.id &&
                this.newAP.alias &&
                this.newAP.server_endpoint &&
                this.newAP.parameters &&
                this.newAP.local_ip &&
                this.newAP.subnet_mask &&
                this.newAP.gateway &&
                this.newAP.heartbeat
                ) ? {
                    id: this.newAP.id,
                    alias: this.newAP.alias,
                    server_endpoint: this.newAP.server_endpoint,
                    parameters: this.newAP.parameters,
                    local_ip: this.newAP.local_ip,
                    subnet_mask: this.newAP.subnet_mask,
                    gateway: this.newAP.gateway,
                    heartbeat: this.newAP.heartbeat,
                    app_version: '1.0.0',
                    is_active: true,
                    store_id: this.activeStore._id,
                } : null;
            if (!payload){
                const error = "Verifica los datos"
                this.$generate_noty('error', this.$t('forms.create_error'), error, 3000, true);
                this.cancel_or_error(error)
                
                this.isSubmitting = false
                return
            }
            this.createUpdateAccessPoint((payload)).then(resp => {
                context.isSubmitting = false
                context.callback(resp)
            })
        },
    },
    mounted(){

        
    },
}
</script>



<template>
    <div>
        <b-modal 
            v-model="isModalVisible" size="sm" 
            :title="`Tienda: ${activeStore && activeStore.name || ''}`" 
            @hide="closeModal('cancel')"
            @ok="assignModalShow = true"
            hide-footer
            >
            <ValidationObserver ref="observer" @submit.prevent="submitForm">
                <b-form ref="createform" >
                    <b-row>
                        <b-col md="12">
                            <h4>Nuevo Access Point</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6">
                            ID (MAC):
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="id"
                                :rules="{'required': true, 'regex': `^[a-zA-Z0-9:]{12}([a-zA-Z0-9:]{5})?$` }">
                                <b-form-input v-model="newAP.id" type="text" name="id" placeholder="ID (MAC)" />
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6">
                            Alias:
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="alias"
                                :rules="{'required': true, 'min': 3 }">
                                <b-form-input v-model="newAP.alias" type="text" name="alias" placeholder="Alias"/>
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="6">
                            Server IP:
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="server_endpoint"
                                :rules="{'required': true, 'min': 7 }">
                                <b-form-input v-model="newAP.server_endpoint" type="text" name="server_endpoint" placeholder="Server IP" />
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="6">
                            Usuario:
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="parameters_user"
                                :rules="{'required': true, 'min': 3 }">
                                <b-form-input v-model="newAP.parameters[0]" type="text" name="parameters_user" placeholder="Usuario"/>
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="6">
                            Contraseña:
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="parameters_password"
                                :rules="{'required': true, 'min': 3 }">
                                <b-form-input v-model="newAP.parameters[1]" type="text" name="parameters_password" placeholder="Contraseña"/>
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="6">
                            IP Local:
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="local_ip"
                                :rules="{'required': true, 'min': 7 }">
                                <b-form-input v-model="newAP.local_ip" type="text" name="local_ip" placeholder="192.168.1.100"/>
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="6">
                            Máscara Subred:
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="subnet_mask"
                                :rules="{'required': true, 'min': 7 }">
                                <b-form-input v-model="newAP.subnet_mask" type="text" name="subnet_mask" placeholder="255.255.255.0"/>
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="6">
                            Puerta de enlace:
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="gateway"
                                :rules="{'required': true, 'min': 7 }">
                                <b-form-input v-model="newAP.gateway" type="text" name="gateway" placeholder="192.168.1.1"/>
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="6">
                            Heartbeat:
                            <ValidationProvider 
                                v-slot="validationContext"
                                name="heartbeat"
                                :rules="{'required': true, 'min_value': 5, 'max_value': 90 }">
                                <b-form-input v-model="newAP.heartbeat" type="number" :min="5" :max="90" name="heartbeat" placeholder="15"/>
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-card-footer class="bg-transparent p-0 mt-3">
                        <b-button size="sm" variant="secondary" @click="closeModal">
                            {{ $t("basic.cancel") }}
                        </b-button>
                        <b-button type="submit" size="sm" variant="primary" :disabled="isSubmitting" class="ml-1">
                            <span v-if="!isSubmitting">
                                {{ $t("basic.add") }}
                            </span>
                            <b-spinner v-if="isSubmitting" small label="Spinning" variant="light"></b-spinner>
                        </b-button>
                    </b-card-footer>
                </b-form>
            </ValidationObserver>
        </b-modal>
        <b-modal
            id="assign-modal"
            v-model="assignModalShow"
            :title="$t('basic.add')"
            :ok-title="$t('basic.add')"
            ok-variant="primary"
            @hidden="() => assignModalShow = false"
            @ok="saveStore"
            >
            <p v-if="newAP">
                <b>Está seguro de agregar este nuevo Access Point?</b>
                <br>
                <br>
                ID (Mac): <b>{{  newAP.id }}</b><br>
                Alias: <b>{{  newAP.alias }}</b><br>
                Server IP: <b> {{ newAP.server_endpoint }}</b><br>
                Usuario/Contraseña: <b> {{ newAP.parameters[0] }}/{{ newAP.parameters[1] }}</b><br>
                IP Local: <b> {{ newAP.local_ip }}</b><br>
                Máscara Subred: <b> {{ newAP.subnet_mask }}</b><br>
                Puerta de enlace: <b> {{ newAP.gateway }}</b><br>
                Heartbeat: <b> {{ newAP.heartbeat }}</b><br>
            </p>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button size="sm" variant="secondary" @click="cancel">
                {{ $t("basic.cancel") }}
                </b-button>
                <b-button size="sm" variant="danger" :disabled="isSubmitting" @click="ok">
                <span v-if="!isSubmitting">
                    {{ $t("basic.accept") }}
                </span>
                <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
                </b-spinner>
                </b-button>
            </template>
        </b-modal>
    </div>
</template>